import React from 'react';
import { X, AlertTriangle, Trash2 } from 'lucide-react';
import './DeleteConfirmModal.css';

const DeleteConfirmModal = ({ item, onClose, onConfirm, loading = false }) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content delete-confirm-modal">
        {/* Header */}
        <div className="modal-header">
          <div className="delete-icon-wrapper">
            <AlertTriangle size={24} />
          </div>
          <button 
            className="btn-icon" 
            onClick={onClose}
            type="button"
            disabled={loading}
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="modal-body">
          <h2 className="delete-title">¿Eliminar Transporte?</h2>
          <p className="delete-message">
            Estás a punto de eliminar el transporte <strong>"{item?.nombre}"</strong>.
          </p>
          <p className="delete-warning">
            Esta acción no se puede deshacer. El transporte será marcado como inactivo.
          </p>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-outline"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={onConfirm}
            disabled={loading}
          >
            <Trash2 size={18} />
            {loading ? 'Eliminando...' : 'Eliminar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
